import React from "react";
import { Link, useLocation } from "react-router-dom";

const MobileBottomNav = () => {
  const location = useLocation();

  const navItems = [
    { path: "/", label: "Home", icon: "bi-house" },
    { path: "/about", label: "About", icon: "bi-info-circle" },
    { path: "/gallery", label: "Gallery", icon: "bi-images" },
    { path: "/blogs", label: "Blogs", icon: "bi-file-text" },
    { path: "/contact", label: "Contact", icon: "bi-envelope" },
  ];

  return (
    <>
      <style>{`
        .mobile-bottom-nav {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          background: #ffffff;
          border-top: 1px solid #e5e5e5;
          display: flex;
          justify-content: space-around;
          align-items: center;
          padding: 1px 0;
          z-index: 1000;
          box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
        }

        .mobile-nav-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-decoration: none;
          color: #666;
          font-size: 11px;
          padding: 4px 12px;
          transition: all 0.3s ease;
        }

        .mobile-nav-item i {
          font-size: 20px;
          margin-bottom: 1px;
        }

        .mobile-nav-item.active {
          color: #000;
          font-weight: bold;
        }

        .mobile-nav-item.active i {
          color: #000;
          font-weight: bold;
        }

        .mobile-nav-item:hover {
          color: #000;
        }

        @media (min-width: 992px) {
          .mobile-bottom-nav {
            display: none;
          }
        }
      `}</style>
      <nav className="mobile-bottom-nav d-lg-none">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`mobile-nav-item ${location.pathname === item.path ? "active" : ""}`}
          >
            <i className={`bi ${item.icon}`}></i>
            <span>{item.label}</span>
          </Link>
        ))}
      </nav>
    </>
  );
};

export default MobileBottomNav;
